import React from 'react';
import Section from './common/Section';

import { FaExternalLinkSquareAlt } from 'react-icons/fa';
import comingSoon from '../assets/comingSoon.png';
import htmlWebsite from '../assets/htmlWebsite.png';
import userAuthReg from '../assets/userAuthReg.png';
import userAuthDashboardAfterLogin from '../assets/userAuthDashboardAfterLogin.png';
import ronkibogHotels from '../assets/ronkibogHotels.png';
import tasteNaija from '../assets/tasteNaija.png';
import mandanaHotels from '../assets/mandanaHotels.png';
import ekitiMarketPlace from '../assets/ekitiMarketPlace.png';
import ecommWithPublicApi from '../assets/ecommWithPublicApi.png';
import bavardeAts from '../assets/bavardeAts.png';
// import userAuth from "../assets/userAuth.png";
// import userAuthLogin from "../assets/userAuthLogin.png";
// import mobile1 from "../assets/mobile1.png";
// import mobile2 from "../assets/mobile2.png";
// import mobile3 from "../assets/mobile3.png";
// import mobile4 from "../assets/mobile4.png";

function Portfolio() {
  const projects = [
    {
      id: 1,
      title: 'Coming Soon Website',
      image: comingSoon,
      website: 'https://starlit-zabaione-373261.netlify.app/',
    },
    {
      id: 2,
      title: 'Created with html and css',
      image: htmlWebsite,
      website: 'https://symphonious-tartufo-6c9ca7.netlify.app/',
    },
    {
      id: 3,
      title: 'User Authentication',
      image: userAuthReg,
      website: 'https://firstsocialmediaapp.onrender.com/',
    },
    {
      id: 4,
      title: 'After user has been authenticated and logged in',
      image: userAuthDashboardAfterLogin,
      website: 'https://firstsocialmediaapp.onrender.com/',
    },
    {
      id: 5,
      title: 'Hotel booking website',
      image: ronkibogHotels,
      website: 'https://ronkibogcrystalhotel.netlify.app/',
    },
    {
      id: 6,
      title: 'Online food booking application',
      image: tasteNaija,
      website: 'https://tastenaijarestaurant.netlify.app/',
    },
    {
      id: 7,
      title: 'Hotel booking website',
      image: mandanaHotels,
      website: 'https://mandanahotels.netlify.app/',
    },
    {
      id: 8,
      title: 'Online Marketplace',
      image: ekitiMarketPlace,
      website: 'https://ekitimarketplace.onrender.com',
    },
    {
      id: 9,
      title: 'Ecommerce Website with public API',
      image: ecommWithPublicApi,
      website: 'https://ecommercewithpublicapi.onrender.com/',
    },
    {
      id: 10,
      title: 'Applicant Tracking System',
      image: bavardeAts,
      website: 'https://bavardeats-frontend.onrender.com/',
    },
  ];
  return (
    <Section
      title="Portfolio 📦"
      subtitle="These are all the projects that I have worked on and they have given me amazing experience. I will always be posting more of the projects I work on here."
    >
      <div className="grid gap-8 lg:gap-14 lg:grid-cols-2">
        {projects.map(({ id, title, image, website }) => (
          <div
            key={id}
            className=" max-w-lg flex shadow-lg shadow-gray-300 rounded-2xl overflow-hidden"
          >
            <img src={image} alt={title} className="w-2/3" loading="lazy" />
            <div className="w-1/3 flex flex-col items-center justify-evenly p-1">
              <h2>{title}</h2>
              <a
                href={website}
                target="_blank"
                rel="noreferrer noopener"
                className="text-2xl cursor-pointer duration-150 hover:scale-110"
              >
                <FaExternalLinkSquareAlt />
              </a>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

export default Portfolio;
